export default "__VITE_ASSET__Dpxxs$81__"